import { OfflineRequestError } from 'utils/errorCodes'
import { ApiRequestQueue } from './api/queue'
import { ApiRequestStatus, ApiRequestType } from './api/queue/types'
import type { NodeRepositionMeta } from './api/serviceCenterNodeReposition'
import { serviceCenterNodeReposition } from './api/serviceCenterNodeReposition'

export const repositionActiveNode = async (param: NodeRepositionMeta) => {
  try {
    // Request may or may not have been completed by the time the promise resolves
    const { status } = await ApiRequestQueue.createRequest(ApiRequestType.REPOSITION_ACTIVE_NODE, param)

    if (status === ApiRequestStatus.COMPLETED) return
  } catch (error) {
    // If the request failed because the app is offline, don't throw an error
    if (!(error instanceof OfflineRequestError)) {
      throw error
    }
  }

  serviceCenterNodeReposition.callback(param)
}
